import { Component } from '@angular/core';
import { FusionAuthService } from 'src/app/modules/club/components/fusion/fusion-callback-auth.service';

@Component({
  selector: 'fgb-fusion-user-login',
  templateUrl: './fusion-user-login.component.html',
  styleUrls: ['./fusion-user-login.component.scss'],
})
export class FusionUserLoginComponent {
  constructor(private fusionAuthService: FusionAuthService) {}

  ngOnInit() {}

  loginFusion() {
    this.fusionAuthService.login().toPromise();
  }
}
